import React from 'react';

const Projects = () => {
    return (
        <div>
            <h1 className='text-center text-5xl font-semibold text-secondary my-5 mt-10'>Recent Projects</h1>
            <div data-aos="fade-up" data-aos-delay='500' data-aos-duration='800' className='hero md:rounded-2xl rounded-none mx-auto relative md:z-50 p-4 md:p-6 md:w-5/6'>

                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 justify-items-center'>

                    <div className="card w-80 shadow-xl">
                        <figure><img className='z-40' src="https://i.ibb.co/S6w5NyS/Screenshot-2022-05-28-at-02-39-10-Sz-Photographs.png" alt="Shoes" /></figure>
                        <div className="mt-[-122px] bg-red-300">
                            <h2 className="card-title z-50 text-white">Sz Photography</h2>
                            <div className="flex justify-end items-end mt-24">
                                <a href='https://sz-photographs.web.app/' target='_blank' className="btn btn-primary btn-sm z-50">Preview</a>
                            </div>
                        </div>
                    </div>
                    <div className="card w-80 shadow-xl">
                        <figure><img className='z-40' src="https://i.ibb.co/H7LTQ82/Screenshot-2022-05-28-at-02-41-56-Watch-World.png" alt="Shoes" /></figure>
                        <div className="mt-[-127px] ">
                            <h2 className="card-title z-50 text-white">Sz Photography</h2>
                            <div className="flex justify-end items-end mt-24">
                                <a href='https://watch-world-c349c.web.app/' target='_blank' className="btn btn-primary btn-sm z-50">Preview</a>
                            </div>
                        </div>
                    </div>
                    <div className="card w-80 shadow-xl">
                        <figure><img className='z-40' src="https://i.ibb.co/5c0MwW3/Screenshot-2022-05-28-at-03-01-39-App.png" alt="Shoes" /></figure>
                        <div className="mt-[-125px] bg-accent">
                            <h2 className="card-title z-50 text-white">Sz Photography</h2>
                            <div className="flex justify-end items-end mt-24">
                                <a href='https://lens-tree.web.app/' target='_blank' className="btn btn-primary btn-sm z-50">Preview</a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Projects;